import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { History, LocationState } from 'history';
import { AxiosError } from 'axios';

import Error from '../../../../components/stateMessage/Error';
import TemplateForm from '../TemplateForm';
import { Itinerary } from '../../../../types/Itinerary';
import { useAppDispatch } from '../../../../store';
import { createItineraryTemplates } from '../../../../services/templates';
import { addItineraryTemplateAction } from '../../../../reduces/itineraryTemplates';

type Props = { history: History<LocationState> };

export const DEFAULT_COLOR = '#46A5C8';

const ItineraryTemplateCreatePage = ({ history }: Props) => {
  const { citySlug } = useParams();
  const dispatch = useAppDispatch();
  const { goBack } = history;
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const hideMessage = () => {
    setTimeout(() => {
      setErrorMessage(undefined);
    }, 5000);
  };

  const onSave = async (template: Itinerary) => {
    try {
      const createdTemplate = await createItineraryTemplates(
        citySlug,
        template
      );
      if (createdTemplate) {
        dispatch(addItineraryTemplateAction(createdTemplate));
      }
      goBack();
    } catch (e) {
      const error = e as AxiosError;
      setErrorMessage(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      hideMessage();
    }
  };

  return (
    <>
      {!!errorMessage && <Error text={errorMessage} />}
      <TemplateForm
        history={history}
        itineraryTemplate={{ citySlug, color: DEFAULT_COLOR }}
        onSave={onSave}
      />
    </>
  );
};

export default ItineraryTemplateCreatePage;
